module.exports = __webpack_public_path__ + "static/media/04.3eefc98c.JPG";